import * as React from "react";

import * as havana from './img/fabXsHavana.jpg';
import * as martinique from './img/fabXsMartinique.jpg';
import * as osumi from './img/fabXsOsumi.jpg';
import * as sandstorm from './img/fabXsSandstorm.jpg';
import * as tokara from './img/fabXsTokara.jpg';
import * as windjammer from './img/fabXsWindjammer.jpg';

import './ColourSelector.css';

const ColourSelector = ({colour, onChange}) => {
   return (
     <div className="fabrics"><div className="fabric"><label>
           <img alt="Windjammer" title="Green" src={String(windjammer)} />
           Windjammer
           <input name="colour" value="windjammer" type="radio" checked={colour === "windjammer"} onChange={onChange} />
       </label></div>
       <div className="fabric"><label>
           <img alt="Tokara" title="Claret, Dark Red" src={String(tokara)} />
           Tokara
           <input name="colour" value="tokara" type="radio" checked={colour === "tokara"} onChange={onChange} />
       </label></div>
       <div className="fabric"><label>
           <img alt="Sandstorm" title="Light Brown" src={String(sandstorm)} />
           Sandstorm
           <input name="colour" value="sandstorm" type="radio" checked={colour === "sandstorm"} onChange={onChange} />
       </label></div>
       <div className="fabric"><label>
           <img alt="Martinique" title="Blue Grey" src={String(martinique)} />
           Martinique
           <input name="colour" value="martinique" type="radio" checked={colour === "martinique"} onChange={onChange} />
       </label></div>
       <div className="fabric"><label>
           <img alt="Osumi" title="Neutral Mid Grey" src={String(osumi)} />
           Osumi
           <input name="colour" value="osumi" type="radio" checked={colour === "osumi"} onChange={onChange} />
       </label></div>
       <div className="fabric"><label>
           <img alt="Havana" title="Black" src={String(havana)} />
           Havana
           <input name="colour" value="havana" type="radio" checked={colour === "havana"} onChange={onChange} />
     </label></div></div>
   );
};

export default ColourSelector;
